import { z } from 'zod';
const UpdateReverifyEmailErrorInboundSchema = z
    .object({
    error: z.string()
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'update_reverify_email_error',
    ...rest
}));
export const UPDATE_REVERIFY_EMAIL_ERROR_PAYLOAD_DEFINITION = {
    zodSchema: UpdateReverifyEmailErrorInboundSchema
};
